<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data() {
    let beforeLabel = this.labelBeforeValue;
    let afterLabel = this.labelAfterValue;
    return {
      chart_options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return beforeLabel + value + afterLabel;
                },
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datas: {},
    };
  },
  mounted() {
    this.fetchDatas();
    // Overwriting base render method with actual data.
  },
  methods: {
    changeUrl(newUrl) {
      this.url = newUrl;
      this.fetchDatas();
    },

    fetchDatas() {
      var url = this.url;
      if (this.stringParameters != null && this.stringParameters != "") {
        url += "?" + this.stringParameters;
      }

      axios.get(url).then((response) => {
        this.datas = response.data;
        this.renderChart(this.datas, this.chart_options);
      });
    },
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    labelBeforeValue: {
      type: String,
      required: false,
      default: "",
    },
    labelAfterValue: {
      type: String,
      required: false,
      default: "",
    },
    stringParameters: {
      type: String,
      required: false,
    },
  },
};
</script>
